import { graphql } from '@graphql/gql';

export const DECLINE_APPOINTMENT = graphql(`
  mutation DECLINE_APPOINTMENT($params: CancelDeclineApptInput!, $source: String) {
    declineAppointment(params: $params, source: $source)
  }
`);
